<template>
  <div class="three-channel-container">
    <!-- 顶部统一查询区域 -->
    <div class="unified-search-container">
      <a-input-group compact style="display: flex; align-items: center">
        <a-input
            v-model="unifiedQuery.queryParam"
            placeholder="请输入单号查询"
            style="width: 180px"
            allowClear
        />
        <a-button
            type="primary"
            @click="handleUnifiedSearch"
            style="margin-left: 8px"
        >
          查询
        </a-button>
        <a-button @click="resetSearch" style="margin-left: 8px">重置</a-button>
      </a-input-group>
    </div>

    <!-- 三通道布局 -->
    <div class="channels-wrapper">
      <!-- 第一通道 -->
      <div class="channel channel-height channel-1">
        <div class="channel-header">
          <h3>主单信息</h3>
          <div class="selected-info" v-if="selectedChannel1">
            <a-icon type="check-circle" theme="filled" style="color: #52c41a; margin-right: 4px;"/>
            <span class="label">当前选择：</span>
            <span class="value">{{ selectedChannel1.mainMailCode }}</span>
            <a-button
                type="link"
                size="small"
                @click.stop="copyToClipboard(selectedChannel1.mainMailCode)"
                style="margin-left: 6px; padding: 0 4px;"
                title="复制"
            >
              <a-icon type="copy" style="font-size: 12px;"/>
            </a-button>
          </div>
        </div>
        <div class="table-container">
          <a-table
              :columns="channel1Columns"
              :dataSource="channel1Data"
              :rowKey="record => record.id"
              :pagination="false"
              size="middle"
              :rowSelection="{selectedRowKeys: selectedChannel1 ? [selectedChannel1.id] : [], type: 'radio'}"
              @change="handleChannel1TableChange"
              @rowClick="handleChannel1Select"
              :scroll="{ x: 'max-content', y: 'calc(100vh - 400px)' }"
          >
          </a-table>
          <a-pagination
              class="pagination"
              size="small"
              :current="channel1Query.current"
              :pageSize="channel1Query.size"
              :total="channel1Total"
              showQuickJumper
              :showTotal="total => `共 ${total} 条`"
              @change="handleChannel1PageChange"
              @showSizeChange="handleChannel1SizeChange"
          />
        </div>
      </div>

      <!-- 第二通道 -->
      <div class="channel channel-height channel-2">
        <div class="channel-header">
          <h3>包裹信息</h3>
          <div class="selected-info" v-if="selectedChannel2">
            <a-icon type="check-circle" theme="filled" style="color: #52c41a; margin-right: 4px;"/>
            <span class="label">当前选择：</span>
            <span class="value">{{ selectedChannel2.sumBoxNum }}</span>
            <a-button
                type="link"
                size="small"
                @click.stop="copyToClipboard(selectedChannel2.sumBoxNum)"
                style="margin-left: 6px; padding: 0 4px;"
                title="复制"
            >
              <a-icon type="copy" style="font-size: 12px;"/>
            </a-button>
          </div>
        </div>
        <div class="table-container">
          <a-table
              :columns="channel2Columns"
              :dataSource="channel2Data"
              :rowKey="record => record.sumBoxNum"
              :pagination="false"
              size="middle"
              :rowSelection="{selectedRowKeys: selectedChannel2 ? [selectedChannel2.sumBoxNum] : [], type: 'radio'}"
              @change="handleChannel2TableChange"
              @rowClick="handleChannel2Select"
              :loading="channel2Loading"
              :scroll="{ x: 'max-content', y: 'calc(100vh - 400px)' }"
          >
          </a-table>
          <a-pagination
              class="pagination"
              size="small"
              :current="channel2Query.current"
              :pageSize="channel2Query.size"
              :total="channel2Total"
              showQuickJumper
              :showTotal="total => `共 ${total} 条`"
              @change="handleChannel2PageChange"
              :disabled="!selectedChannel1"
              @showSizeChange="handleChannel2SizeChange"
          />
        </div>
      </div>

      <!-- 第三通道 -->
      <div class="channel channel-height channel-3">
        <div class="channel-title">
          <h3>订单信息</h3>
        </div>
        <div class="table-container">
          <a-table
              :columns="channel3Columns"
              :dataSource="channel3Data"
              :rowKey="record => record.barCodeNo"
              :pagination="false"
              size="middle"
              @change="handleChannel3TableChange"
              :loading="channel3Loading"
              :scroll="{ x: 'max-content', y: 'calc(100vh - 400px)' }"
          >
            <span slot="tags" slot-scope="tags">
              <a-tag
                  :color="tags == '0' ? 'red' : tags == '1' ? 'green' : tags == '2' ? 'geekblue' : tags == '3' ? 'pink' : ''">
                {{ aDouble(tags + '') }}
              </a-tag>
            </span>
          </a-table>
          <a-pagination
              class="pagination"
              size="small"
              :current="channel3Query.current"
              :pageSize="channel3Query.size"
              :total="channel3Total"
              showQuickJumper
              :showTotal="total => `共 ${total} 条`"
              @change="handleChannel3PageChange"
              :disabled="!selectedChannel2"
              @showSizeChange="handleChannel3SizeChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getChannel1List, getChannel2List, getChannel3List2} from 'api/channel'
import {dictGet} from "api/app";

export default {
  data() {
    return {
      // 统一查询条件
      unifiedQuery: {
        queryParam: '',
      },

      // 第一通道数据
      channel1Columns: [
        {
          title: '主单号',
          align: "center",
          dataIndex: 'mainMailCode'
        },
        {
          title: '发运时间',
          align: "center",
          dataIndex: 'createTime'
        }
      ],
      channel1Data: [],
      channel1Total: 0,
      selectedChannel1: null,
      channel1Query: {
        queryParam: '',
        current: 1,
        size: 10
      },

      // 第二通道数据
      channel2Columns: [
        {
          title: '包号',
          align: "center",
          width: 150,
          dataIndex: 'sumBoxNum'
        },
        {
          title: '总件数',
          align: "center",
          width: 100,
          dataIndex: 'totalCount'
        },
        {
          title: '总重量(KG)',
          align: "center",
          width: 120,
          dataIndex: 'totalWeight'
        }
      ],
      channel2Data: [],
      channel2Total: 0,
      channel2Loading: false,
      selectedChannel2: null,
      channel2Query: {
        queryParam: '',
        current: 1,
        size: 10
      },

      // 第三通道数据
      channel3Columns: [
        {
          title: '标签单号',
          dataIndex: 'barCodeNo',
          align: "center",
          width: 150,
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: "center",
          width: 120,
          scopedSlots: {customRender: 'tags'},
        }, {
          title: '收件人姓名',
          dataIndex: 'toCustLinkman',
          align: "center",
          width: 180,
        },
        {
          title: '收件人地址',
          dataIndex: 'address',
          align: "center",
          width: 220,
        },
        {
          title: '收件人电话',
          dataIndex: 'toCustTel',
          align: "center",
          width: 150,
        }
      ],
      channel3Data: [],
      channel3Total: 0,
      channel3Loading: false,
      channel3Query: {
        queryParam: '',
        current: 1,
        size: 10
      }
    }
  },
  watch: {
    unifiedQuery: {
      handler(newVal) {
        this.channel1Query.queryParam = newVal.queryParam
      },
      deep: true
    }
  },
  computed: {
    aDouble() {
      return function (value) {
        return this.dictEum[value] ? this.dictEum[value] : ""
      }
    },
  },
  mounted() {
    this.loadChannel1Data()
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  async created() {
    let dictEum = await dictGet({
      dictType: ""
    })
    this.dictEum = dictEum.data.order_status
  },
  methods: {
    handleResize() {
      // 响应式调整逻辑可以放在这里
    },
    copyToClipboard(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      document.body.appendChild(textarea)
      textarea.select()

      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success('已复制到剪贴板')
        } else {
          this.$message.error('复制失败')
        }
      } catch (err) {
        this.$message.error('复制失败: ' + err)
      } finally {
        document.body.removeChild(textarea)
      }
    },
    // 加载第一通道数据
    async loadChannel1Data() {
      try {
        const res = await getChannel1List(this.channel1Query)
        this.channel1Data = res.data.records
        this.channel1Total = res.data.total

        if (this.unifiedQuery.queryParam && this.channel1Data.length > 0) {
          this.handleChannel1Select(this.channel1Data[0])
        }
      } catch (error) {
        console.error('加载第一通道数据失败:', error)
        this.$message.error('加载第一通道数据失败')
      }
    },

    // 加载第二通道数据
    async loadChannel2Data() {
      if (!this.selectedChannel1) return
      this.channel2Loading = true

      try {
        const params = {
          ...this.channel2Query,
        }
        const res = await getChannel2List(params)
        this.channel2Data = res.data.records
        this.channel2Total = res.data.total

        if (this.unifiedQuery.queryParam && this.channel2Data.length > 0) {
          this.handleChannel2Select(this.channel2Data[0])
        } else {
          this.channel3Total = 0
          this.channel3Data = []
        }
      } catch (error) {
        console.error('加载第二通道数据失败:', error)
        this.$message.error('加载第二通道数据失败')
      } finally {
        this.channel2Loading = false
      }
    },

    // 加载第三通道数据
    async loadChannel3Data() {
      if (!this.selectedChannel2) return

      this.channel3Loading = true
      try {
        const params = {
          ...this.channel3Query,
        }
        const res = await getChannel3List2(params)
        this.channel3Data = res.data.records
        this.channel3Total = res.data.total
      } catch (error) {
        console.error('加载第三通道数据失败:', error)
        this.$message.error('加载第三通道数据失败')
      } finally {
        this.channel3Loading = false
      }
    },

    // 统一查询
    handleUnifiedSearch() {
      this.channel1Query.current = 1
      this.channel2Query.current = 1
      this.channel3Query.current = 1

      this.selectedChannel1 = null
      this.selectedChannel2 = null

      this.channel1Data = []
      this.channel1Total = 0
      this.channel2Data = []
      this.channel2Total = 0
      this.channel3Data = []
      this.channel3Total = 0

      if (this.unifiedQuery.queryParam) {
        this.loadChannel1Data()
      } else {
        this.loadChannel1Data()
        this.channel2Data = []
        this.channel3Data = []
      }
    },

    // 重置查询
    resetSearch() {
      this.unifiedQuery = {
        queryParam: '',
      }
      this.$nextTick(() => {
        this.handleUnifiedSearch()
      })
    },

    // 第一通道选择
    handleChannel1Select(record) {
      this.selectedChannel1 = record
      if (record) {
        this.channel2Query.current = 1
        this.channel2Query.queryParam = this.unifiedQuery.queryParam !== '' ? this.unifiedQuery.queryParam : record.mainMailCode
        this.loadChannel2Data()
      } else {
        this.channel2Data = []
        this.channel3Data = []
      }
    },

    // 第二通道选择
    handleChannel2Select(record) {
      this.selectedChannel2 = record
      if (record) {
        this.channel3Query.current = 1
        // this.channel3Query.queryParam = this.unifiedQuery.queryParam !=='' ? this.unifiedQuery.queryParam : record.sumBoxNum
        this.channel3Query.queryParam = record.sumBoxNum
        this.loadChannel3Data()
      } else {
        this.channel3Data = []
      }
    },

    // 分页变化处理
    handleChannel1PageChange(page, pageSize) {
      this.channel1Query.current = page
      this.channel1Query.size = pageSize
      this.loadChannel1Data()
    },

    handleChannel2PageChange(page, pageSize) {
      this.channel2Query.current = page
      this.channel2Query.size = pageSize
      this.loadChannel2Data()
    },

    handleChannel3PageChange(page, pageSize) {
      this.channel3Query.current = page
      this.channel3Query.size = pageSize
      this.loadChannel3Data()
    },

    handleChannel1SizeChange(current, size) {
      this.channel1Query.current = 1
      this.channel1Query.size = size
      this.loadChannel1Data()
    },

    handleChannel2SizeChange(current, size) {
      this.channel2Query.current = 1
      this.channel2Query.size = size
      this.loadChannel2Data()
    },

    handleChannel3SizeChange(current, size) {
      this.channel3Query.current = 1
      this.channel3Query.size = size
      this.loadChannel3Data()
    },

    handleChannel1TableChange(pagination) {
      this.channel1Query.current = pagination.current
      this.channel1Query.size = pagination.pageSize
      this.loadChannel1Data()
    },

    handleChannel2TableChange(pagination) {
      this.channel2Query.current = pagination.current
      this.channel2Query.size = pagination.pageSize
      this.loadChannel2Data()
    },

    handleChannel3TableChange(pagination) {
      this.channel3Query.current = pagination.current
      this.channel3Query.size = pagination.pageSize
      this.loadChannel3Data()
    }
  }
}
</script>

<style scoped>
.three-channel-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: #FFFFFF;
  height: calc(100vh - 132px);
  width: 100%;
  box-sizing: border-box;
}

.unified-search-container {
  background: #fafafa;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.channels-wrapper {
  display: flex;
  flex-direction: row;
  gap: 12px;
  height: calc(100vh - 160px);
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  flex: 1;
  min-height: 0;
}

.channel {
  flex: 1;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  min-width: 280px;
  max-width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.channel-height {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.channel-title {
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
}

.channel-title h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 500;
}

.ant-table-tbody > tr:hover > td {
  background-color: white !important;
}

.ant-table-tbody > tr {
  cursor: pointer;
}

.pagination {
  margin-top: 12px;
  text-align: right;
  flex-shrink: 0;
}

/* 调整比例 */
.channel-1 {
  flex: 1 1 30%;
  min-width: 280px;
}

.channel-2 {
  flex: 1 1 30%;
  min-width: 280px;
}

.channel-3 {
  flex: 1 1 40%;
  min-width: 380px;
}

/* 表格容器优化 - 修改这里 */
.table-container {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* 表格样式调整 - 新增这部分 */
.ant-table {
  flex: 1;
  overflow: auto;
}

.ant-table-body {
  height: 100% !important;
  min-height: 0 !important;
}

/* 表格列宽优化 */
.ant-table td {
  padding: 8px 12px !important;
}

/* 第一甬道（主单）列宽调整 */
.channel-1 .ant-table-column-title {
  min-width: 100px;
}

/* 第二甬道（包信息）列宽调整 */
.channel-2 .ant-table-column-title {
  min-width: 80px;
}

/* 第三甬道（订单信息）列宽调整 */
.channel-3 .ant-table-column-title {
  min-width: 120px;
}

/* 选中行高亮样式 */
.ant-table-tbody > tr.ant-table-row-selected > td {
  background-color: #f0f7ff !important;
}

/* 鼠标悬停行样式 */
.ant-table-tbody > tr:hover > td {
  background-color: #f5f5f5 !important;
  cursor: pointer;
}

/* 标题栏样式 */
.channel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
  flex-wrap: wrap;
  gap: 8px;
}

.channel-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

/* 选择信息样式 */
.selected-info {
  display: flex;
  align-items: center;
  font-size: 13px;
  background-color: #f5f5f5;
  padding: 4px 8px;
  border-radius: 4px;
  margin-left: 8px;
  flex-wrap: wrap;
}

.selected-info .label {
  color: #666;
  margin-right: 4px;
}

.selected-info .value {
  font-weight: 500;
  color: #1890ff;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .channels-wrapper {
    flex-wrap: wrap;
    height: auto;
    overflow-x: hidden;
  }

  .channel {
    flex: 1 1 100%;
    min-width: 100%;
    height: auto;
    max-height: 400px;
  }

  .table-container {
    height: 300px;
  }
}

@media (max-width: 768px) {
  .three-channel-container {
    padding: 12px;
  }

  .unified-search-container {
    padding: 8px 12px;
  }

  .channel-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .selected-info {
    margin-left: 0;
    margin-top: 4px;
  }

  .channel {
    padding: 8px;
  }
}
</style>
